module.exports = __webpack_public_path__ + "img/Выписка-из-реестра-лицензий-на-медицинскую-деятельность_Page_4.67736cfe.jpg";